import { render, staticRenderFns } from "./ReportPreTrialNoticesIssued.vue?vue&type=template&id=72f17dcc&scoped=true&"
import script from "./ReportPreTrialNoticesIssued.vue?vue&type=script&lang=js&"
export * from "./ReportPreTrialNoticesIssued.vue?vue&type=script&lang=js&"
import style0 from "./ReportPreTrialNoticesIssued.vue?vue&type=style&index=0&id=72f17dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f17dcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VContainer,VRadio,VRadioGroup,VRow,VTextField})
